export function Upload() {
  return (
    <>
      <h2 className='text-2xl font-black uppercase'>Upload Edits</h2>
      <div className='mt-8 flex min-h-[40vh] items-center justify-center rounded-2xl border border-white/10 bg-black/20 p-12 text-center'>
        <div>
          <p className='text-xs font-black uppercase tracking-[0.35em] text-prime-red'>Admin Upload</p>
          <h3 className='mt-4 text-3xl font-black'>COMING SOON</h3>
          <p className='mt-3 text-sm text-white/50 max-w-md mx-auto'>
            We are preparing our cloud infrastructure. Secure multi-track upload features will be available here shortly.
          </p>
        </div>
      </div>
    </>
  );
}
